import { render } from "./PathToImprove.vue?vue&type=template&id=545a39d4&scoped=true"
import script from "./PathToImprove.vue?vue&type=script&lang=js"
export * from "./PathToImprove.vue?vue&type=script&lang=js"

import "./PathToImprove.vue?vue&type=style&index=0&id=545a39d4&scoped=true&lang=css"

import exportComponent from "/Users/sophiasharif/Desktop/projects/i-hate-pinia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-545a39d4"]])

export default __exports__